import { useScanDeviceApiGetQuery, SwrConfig } from '@hooks/api/useScanDeviceApiGetQuery';
import type { Organization } from 'types/api';

export const useClientOrganizations = (swrConfig?: SwrConfig<Organization[]>) =>
  useScanDeviceApiGetQuery<Organization[]>('/organizations/clients', swrConfig);
